import { useState, useEffect, useCallback, useMemo } from 'react';
import DatePicker from '../../components/DatePicker';
import UsageInfo from '../../components/UsageInfo';
import { getSistemLoglar, apiRequest } from '../../services/api';
import { downloadExcel, printTable } from '../../utils/exportUtils';
import EmptyState from '../../components/EmptyState';
import PageHeader from '../../components/PageHeader';
import Pagination from '../../components/Pagination';

// ── Yardımcılar ───────────────────────────────────────────────────────────
function pad(n) { return String(n).padStart(2, '0'); }
function bugunStr() { var d=new Date(); return pad(d.getDate())+'.'+pad(d.getMonth()+1)+'.'+d.getFullYear(); }
function dunStr()   { var d=new Date(); d.setDate(d.getDate()-1); return pad(d.getDate())+'.'+pad(d.getMonth()+1)+'.'+d.getFullYear(); }
function toIso(ddmmyyyy) {
  if (!ddmmyyyy) return '';
  var p = ddmmyyyy.split('.');
  if (p.length < 3) return '';
  return p[2]+'-'+p[1]+'-'+p[0];
}
function parseDetay(detayJson) {
  if (!detayJson) return null;
  try { return JSON.parse(detayJson); } catch { return null; }
}

// ── Log tipleri & renkleri ────────────────────────────────────────────────
const TIP_META = {
  // Oturum
  'giris':             { label:'Giriş',               renk:'bg-blue-100 text-blue-700',    ikon:'🔑' },
  'cikis':             { label:'Çıkış',               renk:'bg-gray-100 text-gray-600',    ikon:'🚪' },
  // Rezervasyon
  'rezervasyon':       { label:'Rezervasyon Eklendi', renk:'bg-purple-100 text-purple-700',ikon:'📋' },
  'rezervasyon_guncelle': { label:'Rezervasyon Güncellendi', renk:'bg-violet-100 text-violet-700', ikon:'✏️' },
  'rezervasyon_sil':   { label:'Rezervasyon Silindi', renk:'bg-red-100 text-red-700',      ikon:'🗑️' },
  'checkin':           { label:'Check-in',            renk:'bg-indigo-100 text-indigo-700',ikon:'✅' },
  'checkout':          { label:'Check-out',           renk:'bg-pink-100 text-pink-700',    ikon:'🏁' },
  'iptal':             { label:'İptal',               renk:'bg-red-100 text-red-700',      ikon:'❌' },
  // Kasa
  'gelir_ekle':        { label:'Gelir Eklendi',       renk:'bg-green-100 text-green-700',  ikon:'💰' },
  'gelir_guncelle':    { label:'Gelir Güncellendi',   renk:'bg-teal-100 text-teal-700',    ikon:'✏️' },
  'gelir_sil':         { label:'Gelir Silindi',       renk:'bg-red-100 text-red-700',      ikon:'🗑️' },
  'gider_ekle':        { label:'Gider Eklendi',       renk:'bg-orange-100 text-orange-700',ikon:'💸' },
  'gider_guncelle':    { label:'Gider Güncellendi',   renk:'bg-yellow-100 text-yellow-700',ikon:'✏️' },
  'gider_sil':         { label:'Gider Silindi',       renk:'bg-red-100 text-red-700',      ikon:'🗑️' },
  // Ödeme & Adisyon
  'odeme_ekle':        { label:'Ödeme Alındı',        renk:'bg-emerald-100 text-emerald-700',ikon:'💳' },
  'odeme_sil':         { label:'Ödeme Silindi',       renk:'bg-red-100 text-red-700',      ikon:'🗑️' },
  'adisyon_ekle':      { label:'Adisyon Eklendi',     renk:'bg-amber-100 text-amber-700',  ikon:'🧾' },
  'adisyon_ode':       { label:'Adisyon Ödendi',      renk:'bg-emerald-100 text-emerald-700',ikon:'💳' },
  'adisyon_sil':       { label:'Adisyon Silindi',     renk:'bg-red-100 text-red-700',      ikon:'🗑️' },
  // Taksit
  'taksit_ekle':       { label:'Taksit Planı Oluşturuldu', renk:'bg-cyan-100 text-cyan-700', ikon:'📅' },
  'taksit_sil':        { label:'Taksit Planı Silindi',renk:'bg-red-100 text-red-700',      ikon:'🗑️' },
  'taksit_odendi':     { label:'Taksit Ödendi',       renk:'bg-green-100 text-green-700',  ikon:'✅' },
  // Misafir & Personel
  'misafir_ekle':      { label:'Misafir Eklendi',     renk:'bg-sky-100 text-sky-700',      ikon:'👤' },
  'misafir_guncelle':  { label:'Misafir Güncellendi', renk:'bg-sky-100 text-sky-700',      ikon:'✏️' },
  'misafir_sil':       { label:'Misafir Silindi',     renk:'bg-red-100 text-red-700',      ikon:'🗑️' },
  'personel_ekle':     { label:'Personel Eklendi',    renk:'bg-lime-100 text-lime-700',    ikon:'👷' },
  'personel_guncelle': { label:'Personel Güncellendi',renk:'bg-lime-100 text-lime-700',    ikon:'✏️' },
  'personel_sil':      { label:'Personel Silindi',    renk:'bg-red-100 text-red-700',      ikon:'🗑️' },
  // Oda
  'oda_ekle':          { label:'Oda Eklendi',         renk:'bg-blue-100 text-blue-700',    ikon:'🏠' },
  'oda_guncelle':      { label:'Oda Güncellendi',     renk:'bg-blue-100 text-blue-700',    ikon:'✏️' },
  'oda_sil':           { label:'Oda Silindi',         renk:'bg-red-100 text-red-700',      ikon:'🗑️' },
  // Acente
  'acente_ekle':       { label:'Acente Eklendi',      renk:'bg-fuchsia-100 text-fuchsia-700',ikon:'🏢' },
  'acente_guncelle':   { label:'Acente Güncellendi',  renk:'bg-fuchsia-100 text-fuchsia-700',ikon:'✏️' },
  'acente_sil':        { label:'Acente Silindi',      renk:'bg-red-100 text-red-700',      ikon:'🗑️' },
  // Cari
  'cari_ekle':         { label:'Cari Eklendi',        renk:'bg-rose-100 text-rose-700',    ikon:'🏦' },
  'cari_guncelle':     { label:'Cari Güncellendi',    renk:'bg-rose-100 text-rose-700',    ikon:'✏️' },
  'cari_sil':          { label:'Cari Silindi',        renk:'bg-red-100 text-red-700',      ikon:'🗑️' },
  'hareket_ekle':      { label:'Cari Hareket Eklendi',renk:'bg-rose-100 text-rose-700',    ikon:'💹' },
  'hareket_guncelle':  { label:'Cari Hareket Güncellendi',renk:'bg-rose-100 text-rose-700',ikon:'✏️' },
  'hareket_sil':       { label:'Cari Hareket Silindi',renk:'bg-red-100 text-red-700',      ikon:'🗑️' },
  // Stok
  'stok_ekle':         { label:'Stok Eklendi',        renk:'bg-stone-100 text-stone-700',  ikon:'📦' },
  'stok_guncelle':     { label:'Stok Güncellendi',    renk:'bg-stone-100 text-stone-700',  ikon:'✏️' },
  'stok_sil':          { label:'Stok Silindi',        renk:'bg-red-100 text-red-700',      ikon:'🗑️' },
  'stok_giris':        { label:'Stok Girişi',         renk:'bg-stone-100 text-stone-700',  ikon:'📥' },
  'stok_grubu_ekle':   { label:'Stok Grubu Eklendi',  renk:'bg-stone-100 text-stone-700',  ikon:'📦' },
  'stok_grubu_guncelle':{ label:'Stok Grubu Güncellendi',renk:'bg-stone-100 text-stone-700',ikon:'✏️' },
  'stok_grubu_sil':    { label:'Stok Grubu Silindi',  renk:'bg-red-100 text-red-700',      ikon:'🗑️' },
  // Kara Liste
  'kara_liste_ekle':   { label:'Kara Listeye Eklendi',renk:'bg-red-100 text-red-700',      ikon:'🚫' },
  'kara_liste_sil':    { label:'Kara Listeden Silindi',renk:'bg-gray-100 text-gray-600',   ikon:'✅' },
  // Personel Gider
  'personel_gider_ekle':   { label:'Personel Gider Eklendi',   renk:'bg-orange-100 text-orange-700',ikon:'💸' },
  'personel_gider_guncelle':{ label:'Personel Gider Güncellendi',renk:'bg-yellow-100 text-yellow-700',ikon:'✏️' },
  'personel_gider_sil':    { label:'Personel Gider Silindi',   renk:'bg-red-100 text-red-700',      ikon:'🗑️' },
  // Sabit Gider
  'sabit_gider_ekle':  { label:'Sabit Gider Eklendi', renk:'bg-orange-100 text-orange-700',ikon:'📌' },
  'sabit_gider_guncelle':{ label:'Sabit Gider Güncellendi',renk:'bg-yellow-100 text-yellow-700',ikon:'✏️' },
  'sabit_gider_sil':   { label:'Sabit Gider Silindi', renk:'bg-red-100 text-red-700',      ikon:'🗑️' },
  // Oda Tanımları
  'oda_tipi_ekle':     { label:'Oda Tipi Eklendi',    renk:'bg-blue-100 text-blue-700',    ikon:'🏠' },
  'oda_tipi_guncelle': { label:'Oda Tipi Güncellendi',renk:'bg-blue-100 text-blue-700',    ikon:'✏️' },
  'oda_tipi_sil':      { label:'Oda Tipi Silindi',    renk:'bg-red-100 text-red-700',      ikon:'🗑️' },
  'oda_grubu_ekle':    { label:'Oda Grubu Eklendi',   renk:'bg-blue-100 text-blue-700',    ikon:'🏠' },
  'oda_grubu_guncelle':{ label:'Oda Grubu Güncellendi',renk:'bg-blue-100 text-blue-700',   ikon:'✏️' },
  'oda_grubu_sil':     { label:'Oda Grubu Silindi',   renk:'bg-red-100 text-red-700',      ikon:'🗑️' },
  'oda_durum_guncelle':{ label:'Oda Durumu Güncellendi',renk:'bg-blue-100 text-blue-700',  ikon:'🔄' },
  'oda_fiyat_guncelle':{ label:'Oda Fiyatı Güncellendi',renk:'bg-blue-100 text-blue-700', ikon:'💰' },
  'oda_ozel_fiyat_ekle':{ label:'Özel Fiyat Eklendi', renk:'bg-blue-100 text-blue-700',   ikon:'💰' },
  'oda_ozel_fiyat_sil':{ label:'Özel Fiyat Silindi',  renk:'bg-red-100 text-red-700',      ikon:'🗑️' },
  // Otel
  'otel_ekle':         { label:'Otel Oluşturuldu',    renk:'bg-purple-100 text-purple-700',ikon:'🏨' },
  'otel_guncelle':     { label:'Otel Güncellendi',    renk:'bg-purple-100 text-purple-700',ikon:'✏️' },
  'personel_otel_ekle':{ label:'Personel Otele Eklendi',renk:'bg-lime-100 text-lime-700', ikon:'👷' },
  'personel_otel_cikar':{ label:'Personel Otelden Çıkarıldı',renk:'bg-red-100 text-red-700',ikon:'🚪' },
  // Tanım Tabloları
  'gelir_grubu_ekle':  { label:'Gelir Grubu Eklendi', renk:'bg-green-100 text-green-700',  ikon:'📂' },
  'gelir_grubu_guncelle':{ label:'Gelir Grubu Güncellendi',renk:'bg-teal-100 text-teal-700',ikon:'✏️' },
  'gelir_grubu_sil':   { label:'Gelir Grubu Silindi', renk:'bg-red-100 text-red-700',      ikon:'🗑️' },
  'gelir_grubu_aktif': { label:'Gelir Grubu Durumu',  renk:'bg-teal-100 text-teal-700',    ikon:'🔄' },
  'gider_grubu_ekle':  { label:'Gider Grubu Eklendi', renk:'bg-orange-100 text-orange-700',ikon:'📂' },
  'gider_grubu_guncelle':{ label:'Gider Grubu Güncellendi',renk:'bg-yellow-100 text-yellow-700',ikon:'✏️' },
  'gider_grubu_sil':   { label:'Gider Grubu Silindi', renk:'bg-red-100 text-red-700',      ikon:'🗑️' },
  'gider_grubu_aktif': { label:'Gider Grubu Durumu',  renk:'bg-yellow-100 text-yellow-700',ikon:'🔄' },
  'konaklama_turu_ekle':{ label:'Konaklama Türü Eklendi',renk:'bg-cyan-100 text-cyan-700', ikon:'🏖️' },
  'konaklama_turu_guncelle':{ label:'Konaklama Türü Güncellendi',renk:'bg-cyan-100 text-cyan-700',ikon:'✏️' },
  'konaklama_turu_sil':{ label:'Konaklama Türü Silindi',renk:'bg-red-100 text-red-700',   ikon:'🗑️' },
  'banka_ekle':        { label:'Banka Tanımı Eklendi',renk:'bg-indigo-100 text-indigo-700',ikon:'🏦' },
  'banka_guncelle':    { label:'Banka Tanımı Güncellendi',renk:'bg-indigo-100 text-indigo-700',ikon:'✏️' },
  'banka_sil':         { label:'Banka Tanımı Silindi',renk:'bg-red-100 text-red-700',      ikon:'🗑️' },
  'misafir_tipi_ekle': { label:'Misafir Tipi Eklendi',renk:'bg-sky-100 text-sky-700',      ikon:'👤' },
  'misafir_tipi_guncelle':{ label:'Misafir Tipi Güncellendi',renk:'bg-sky-100 text-sky-700',ikon:'✏️' },
  'misafir_tipi_sil':  { label:'Misafir Tipi Silindi',renk:'bg-red-100 text-red-700',      ikon:'🗑️' },
  'personel_tipi_ekle':{ label:'Personel Tipi Eklendi',renk:'bg-lime-100 text-lime-700',   ikon:'👷' },
  'personel_tipi_guncelle':{ label:'Personel Tipi Güncellendi',renk:'bg-lime-100 text-lime-700',ikon:'✏️' },
  'personel_tipi_sil': { label:'Personel Tipi Silindi',renk:'bg-red-100 text-red-700',     ikon:'🗑️' },
  'personel_tipi_aktif':{ label:'Personel Tipi Durumu',renk:'bg-lime-100 text-lime-700',   ikon:'🔄' },
  'faturalama_tipi_ekle':{ label:'Faturalama Tipi Eklendi',renk:'bg-violet-100 text-violet-700',ikon:'🧾' },
  'faturalama_tipi_guncelle':{ label:'Faturalama Tipi Güncellendi',renk:'bg-violet-100 text-violet-700',ikon:'✏️' },
  'faturalama_tipi_sil':{ label:'Faturalama Tipi Silindi',renk:'bg-red-100 text-red-700',  ikon:'🗑️' },
  'faturalama_tipi_aktif':{ label:'Faturalama Tipi Durumu',renk:'bg-violet-100 text-violet-700',ikon:'🔄' },
  'odeme_tipi_ekle':   { label:'Ödeme Tipi Eklendi',  renk:'bg-emerald-100 text-emerald-700',ikon:'💳' },
  'odeme_tipi_guncelle':{ label:'Ödeme Tipi Güncellendi',renk:'bg-emerald-100 text-emerald-700',ikon:'✏️' },
  'odeme_tipi_sil':    { label:'Ödeme Tipi Silindi',  renk:'bg-red-100 text-red-700',      ikon:'🗑️' },
  'para_birimi_ekle':  { label:'Para Birimi Eklendi', renk:'bg-yellow-100 text-yellow-700',ikon:'💱' },
  'para_birimi_guncelle':{ label:'Para Birimi Güncellendi',renk:'bg-yellow-100 text-yellow-700',ikon:'✏️' },
  'para_birimi_sil':   { label:'Para Birimi Silindi', renk:'bg-red-100 text-red-700',      ikon:'🗑️' },
  'doluluk_fiyat_ekle':{ label:'Doluluk Fiyat Kuralı Eklendi',renk:'bg-amber-100 text-amber-700',ikon:'📊' },
  'doluluk_fiyat_guncelle':{ label:'Doluluk Fiyat Kuralı Güncellendi',renk:'bg-amber-100 text-amber-700',ikon:'✏️' },
  'doluluk_fiyat_sil': { label:'Doluluk Fiyat Kuralı Silindi',renk:'bg-red-100 text-red-700',ikon:'🗑️' },
  // Laundry & Buklet
  'laundry_ekle':      { label:'Laundry Kaydı Eklendi',renk:'bg-teal-100 text-teal-700',  ikon:'👕' },
  'laundry_guncelle':  { label:'Laundry Kaydı Güncellendi',renk:'bg-teal-100 text-teal-700',ikon:'✏️' },
  'laundry_sil':       { label:'Laundry Kaydı Silindi',renk:'bg-red-100 text-red-700',     ikon:'🗑️' },
  'laundry_kayit_ekle':{ label:'Laundry Kaydı Eklendi',renk:'bg-teal-100 text-teal-700',  ikon:'👕' },
  'laundry_kayit_sil': { label:'Laundry Kaydı Silindi',renk:'bg-red-100 text-red-700',     ikon:'🗑️' },
  'laundry_kalemi_ekle':{ label:'Laundry Kalemi Eklendi',renk:'bg-teal-100 text-teal-700',ikon:'👕' },
  'laundry_kalemi_guncelle':{ label:'Laundry Kalemi Güncellendi',renk:'bg-teal-100 text-teal-700',ikon:'✏️' },
  'laundry_kalemi_sil':{ label:'Laundry Kalemi Silindi',renk:'bg-red-100 text-red-700',    ikon:'🗑️' },
  'buklet_ekle':       { label:'Buklet Kalemi Eklendi',renk:'bg-pink-100 text-pink-700',   ikon:'🛏️' },
  'buklet_guncelle':   { label:'Buklet Kalemi Güncellendi',renk:'bg-pink-100 text-pink-700',ikon:'✏️' },
  'buklet_sil':        { label:'Buklet Kalemi Silindi',renk:'bg-red-100 text-red-700',     ikon:'🗑️' },
  'buklet_toggle':     { label:'Buklet Durumu Değişti',renk:'bg-pink-100 text-pink-700',   ikon:'🔄' },
  // Diğer
  'ayar':              { label:'Ayar Değişikliği',    renk:'bg-gray-100 text-gray-600',    ikon:'⚙️' },
};

// ── SortIcon ──────────────────────────────────────────────────────────────
function SortIcon({ field, sortKey, sortDir }) {
  if (sortKey !== field) return <span className="text-gray-300 ml-1 text-xs">⇅</span>;
  return <span className="text-blue-500 ml-1 text-xs">{sortDir === 'asc' ? '↑' : '↓'}</span>;
}

// ── Detay Tablo ───────────────────────────────────────────────────────────
function DetayTablo({ detay }) {
  if (!detay) return null;
  return (
    <div className="mt-1.5 ml-2 overflow-x-auto rounded-lg border border-gray-200 bg-white shadow-sm">
      <table className="text-xs border-collapse">
        <thead>
          <tr className="bg-gray-100 border-b border-gray-200">
            {detay.kolonlar.map(function(k) {
              return <th key={k} className="px-3 py-1.5 text-left font-semibold text-gray-600 whitespace-nowrap">{k}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          <tr>
            {detay.satir.map(function(v, i) {
              return <td key={i} className="px-3 py-1.5 text-gray-700 whitespace-nowrap border-b border-gray-100">{v||'—'}</td>;
            })}
          </tr>
        </tbody>
      </table>
    </div>
  );
}

// ── Ana Sayfa ─────────────────────────────────────────────────────────────
export default function LogKayitlari() {
  var [aktifSekme, setAktifSekme] = useState('sistem');
  var [baslar,    setBaslar]    = useState(dunStr());
  var [bitis,     setBitis]     = useState(bugunStr());
  var [islem,     setIslem]     = useState('');
  var [aktifBas,  setAktifBas]  = useState(dunStr());
  var [aktifBit,  setAktifBit]  = useState(bugunStr());
  var [aktifIslem,setAktifIslem]= useState('');
  var [colTarih,    setColTarih]    = useState('');
  var [colPersonel, setColPersonel] = useState('');
  var [colIslem,    setColIslem]    = useState('');
  var [sortKey,   setSortKey]   = useState('tarih');
  var [sortDir,   setSortDir]   = useState('desc');
  var [aciklar,   setAciklar]   = useState({});
  var [ham,         setHam]         = useState([]);
  var [toplamKayit, setToplamKayit] = useState(0);
  var [yukleniyor,  setYukleniyor]  = useState(false);
  var [hata,        setHata]        = useState(null);
  var [aktifSayfa,  setAktifSayfa]  = useState(1);
  var [sayfaBasi,   setSayfaBasi]   = useState(50);

  // ── Uyarı Logu ───────────────────────────────────────────────────────────
  var [uyariLoglar, setUyariLoglar] = useState([]);
  var [uyariYukleniyor, setUyariYukleniyor] = useState(false);

  var uyariLogYukle = useCallback(async function() {
    setUyariYukleniyor(true);
    try {
      var data = await apiRequest('uyari/log');
      setUyariLoglar(data || []);
    } catch {}
    setUyariYukleniyor(false);
  }, []);

  useEffect(function() {
    if (aktifSekme === 'uyari') uyariLogYukle();
  }, [aktifSekme, uyariLogYukle]);

  var yukle = useCallback(function() {
    setYukleniyor(true);
    setHata(null);
    getSistemLoglar({
      baslangic:   toIso(aktifBas),
      bitis:       toIso(aktifBit),
      islem:       aktifIslem || undefined,
      sayfa:       aktifSayfa,
      sayfaBoyutu: sayfaBasi,
    }).then(function(data) {
      var rows = (data?.satirlar || []).map(function(l) {
        return Object.assign({}, l, { detay: parseDetay(l.detayJson) });
      });
      setHam(rows);
      setToplamKayit(data?.toplamKayit || 0);
    }).catch(function() {
      setHata('Veriler yüklenemedi.');
    }).finally(function() {
      setYukleniyor(false);
    });
  }, [aktifBas, aktifBit, aktifIslem, aktifSayfa, sayfaBasi]);

  useEffect(function() { yukle(); }, [yukle]);

  function filtrele() { setAktifSayfa(1); setAktifBas(baslar); setAktifBit(bitis); setAktifIslem(islem); }
  function temizle() {
    setAktifSayfa(1);
    setBaslar(dunStr()); setBitis(bugunStr()); setIslem('');
    setAktifBas(dunStr()); setAktifBit(bugunStr()); setAktifIslem('');
    setColTarih(''); setColPersonel(''); setColIslem('');
  }
  function handleSort(key) {
    if (sortKey === key) setSortDir(function(d){ return d==='asc'?'desc':'asc'; });
    else { setSortKey(key); setSortDir('desc'); }
  }
  function toggleDetay(id) {
    setAciklar(function(prev){ return Object.assign({}, prev, { [id]: !prev[id] }); });
  }

  function excelIndir() {
    var baslik = ['Tarih','Saat','Kullanıcı','Tip','İşlem'];
    var satirlar = liste.map(function(l) {
      return [l.tarih, l.saat, l.kullanici, l.tip, l.mesaj];
    });
    downloadExcel('log_kayitlari', 'Log Kayıtları', baslik, satirlar);
  }

  function yazdir() {
    var baslik = ['Tarih','Saat','Kullanıcı','Tip','İşlem'];
    var satirlar = liste.map(function(l) { return [l.tarih, l.saat, l.kullanici, l.tip, l.mesaj]; });
    printTable('İşlem Kayıtları', baslik, satirlar, liste.length + ' kayıt');
  }

  var liste = useMemo(function() {
    return ham.filter(function(l) {
      if (colTarih    && !(l.tarih+' '+l.saat).includes(colTarih)) return false;
      if (colPersonel && !(l.kullanici||'').toLocaleLowerCase('tr-TR').includes(colPersonel.toLocaleLowerCase('tr-TR'))) return false;
      if (colIslem    && !l.mesaj.toLocaleLowerCase('tr-TR').includes(colIslem.toLocaleLowerCase('tr-TR'))) return false;
      return true;
    }).sort(function(a, b) {
      var av, bv;
      if (sortKey === 'tarih') {
        // dd.MM.yyyy HH:mm → karşılaştırılabilir string için yyyy.MM.dd HH:mm yap
        var toSort = function(t, s) { var p=t.split('.'); return p[2]+'.'+p[1]+'.'+p[0]+' '+(s||''); };
        av = toSort(a.tarih, a.saat);
        bv = toSort(b.tarih, b.saat);
      } else {
        av = a[sortKey]||'';
        bv = b[sortKey]||'';
      }
      if (av < bv) return sortDir==='asc'?-1:1;
      if (av > bv) return sortDir==='asc'?1:-1;
      return 0;
    });
  }, [ham, colTarih, colPersonel, colIslem, sortKey, sortDir]);

  var listePage = liste;

  var tipSayilari = useMemo(function() {
    var map = {};
    liste.forEach(function(l) {
      map[l.tip] = (map[l.tip]||0) + 1;
    });
    return map;
  }, [liste]);

  var INP_COL = 'w-full border border-gray-200 rounded-lg px-2 py-1.5 text-xs focus:outline-none focus:border-blue-400 bg-gray-50';

  return (
    <div className="p-3 md:p-6 space-y-8 min-h-screen bg-gray-50/50" style={{ animation: 'fadeIn 0.3s ease-out' }}>

      <PageHeader
        icon="📋"
        iconColor="from-slate-600 to-gray-800"
        iconShadow="shadow-slate-200"
        title="Sistem Log Kayıtları"
        subtitle="Güvenlik ve Personel İzleme"
      >
        <div className="flex flex-wrap gap-4 items-center">
          <button onClick={excelIndir} className="flex-1 md:flex-none flex items-center justify-center gap-3 bg-white border-2 border-emerald-100 hover:border-emerald-500 hover:bg-emerald-50 text-emerald-700 font-black px-6 py-4 rounded-2xl shadow-lg shadow-emerald-50 transition-all text-[10px] uppercase tracking-widest hover:-translate-y-1 active:scale-95 whitespace-nowrap">
            <span>📊</span> EXCEL'E AKTAR
          </button>
          <button onClick={yazdir} className="flex-1 md:flex-none flex items-center justify-center gap-3 bg-white border-2 border-gray-100 hover:border-gray-800 hover:bg-gray-800 hover:text-white text-gray-700 font-black px-6 py-4 rounded-2xl shadow-lg shadow-gray-50 transition-all text-[10px] uppercase tracking-widest hover:-translate-y-1 active:scale-95 whitespace-nowrap">
            <span>🖨️</span> YAZDIR
          </button>
        </div>
      </PageHeader>

      {/* Sekmeler */}
      <div className="flex gap-2 bg-gray-100/80 rounded-[2rem] p-2 w-fit border border-gray-200">
        {[
          { key: 'sistem', label: '📋 SİSTEM LOGLARI' },
          { key: 'uyari',  label: '⏰ UYARI LOGLARI' },
        ].map(s => (
          <button key={s.key} onClick={() => setAktifSekme(s.key)}
            className={`px-6 py-3.5 rounded-2xl text-[10px] font-black tracking-widest uppercase transition-all duration-300 ${aktifSekme === s.key ? 'bg-white text-slate-800 shadow-lg shadow-slate-200 scale-[1.02]' : 'text-gray-500 hover:text-gray-800 hover:bg-gray-50/50'}`}>
            {s.label}
          </button>
        ))}
      </div>

      {aktifSekme === 'uyari' && (
        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
          <div className="flex items-center justify-between px-5 py-3.5 border-b border-gray-100">
            <span className="text-sm font-bold text-gray-800">⏰ Görev Hatırlatıcı Logları</span>
            <button onClick={uyariLogYukle} className="text-xs text-blue-600 hover:underline font-semibold">Yenile</button>
          </div>
          {uyariYukleniyor ? (
            <div className="py-12 text-center text-gray-400 text-sm">Yükleniyor...</div>
          ) : uyariLoglar.length === 0 ? (
            <div className="py-12 text-center text-gray-400 text-sm">Kayıt bulunamadı.</div>
          ) : (
            <>
            <div className="md:hidden p-3 space-y-2">
              {uyariLoglar.map(function(u) {
                var gonderilmeTxt = new Date(u.gonderilmeSaati).toLocaleString('tr-TR', {day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit'});
                var onaylanmaTxt = u.onaylanmaSaati ? new Date(u.onaylanmaSaati).toLocaleString('tr-TR', {day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit'}) : '—';
                var sureTxt = u.yanitSuresiSaniye != null ? (u.yanitSuresiSaniye >= 60 ? `${Math.floor(u.yanitSuresiSaniye/60)} dk ${u.yanitSuresiSaniye%60} sn` : `${u.yanitSuresiSaniye} sn`) : '—';
                return (
                  <div key={u.personelUyariLogId} className="bg-white border border-gray-200 rounded-xl p-3">
                    <div className="flex items-start justify-between mb-2">
                      <p className="font-semibold text-gray-800 text-sm">{u.personelAdSoyad || `#${u.personelId}`}</p>
                      {u.yanitlandiMi
                        ? <span className="text-xs font-semibold bg-emerald-100 text-emerald-700 px-2 py-0.5 rounded-full">✓ Yanıtlandı</span>
                        : u.bildirimGonderildiMi
                          ? <span className="text-xs font-semibold bg-red-100 text-red-700 px-2 py-0.5 rounded-full">⚠ Bildirim</span>
                          : <span className="text-xs font-semibold bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full">⏳ Bekliyor</span>}
                    </div>
                    <div className="space-y-1 text-xs text-gray-600">
                      <div><span className="text-gray-400">Gönderilme: </span>{gonderilmeTxt}</div>
                      <div><span className="text-gray-400">Onaylanma: </span>{onaylanmaTxt}</div>
                      <div><span className="text-gray-400">Yanıt Süresi: </span><strong>{sureTxt}</strong></div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="hidden md:block overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-gray-100 bg-gray-50/50">
                    {['Personel', 'Gönderilme Saati', 'Onaylanma Saati', 'Yanıt Süresi', 'Durum'].map(h => (
                      <th key={h} className="text-left py-3 px-5 font-semibold text-gray-500 text-xs uppercase tracking-wide">{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {uyariLoglar.map(u => {
                    const gonderilme = new Date(u.gonderilmeSaati);
                    const gonderilmeTxt = gonderilme.toLocaleString('tr-TR', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' });
                    const onaylanmaTxt = u.onaylanmaSaati
                      ? new Date(u.onaylanmaSaati).toLocaleString('tr-TR', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' })
                      : '—';
                    const sureTxt = u.yanitSuresiSaniye != null
                      ? u.yanitSuresiSaniye >= 60
                        ? `${Math.floor(u.yanitSuresiSaniye/60)} dk ${u.yanitSuresiSaniye%60} sn`
                        : `${u.yanitSuresiSaniye} sn`
                      : '—';
                    return (
                      <tr key={u.personelUyariLogId} className="border-b border-gray-50 hover:bg-gray-50/50">
                        <td className="py-3 px-5 font-semibold text-gray-800">{u.personelAdSoyad || `#${u.personelId}`}</td>
                        <td className="py-3 px-5 text-gray-600 text-xs">{gonderilmeTxt}</td>
                        <td className="py-3 px-5 text-gray-600 text-xs">{onaylanmaTxt}</td>
                        <td className="py-3 px-5 text-gray-600 text-xs">{sureTxt}</td>
                        <td className="py-3 px-5">
                          {u.yanitlandiMi
                            ? <span className="text-xs font-semibold bg-emerald-100 text-emerald-700 px-2.5 py-1 rounded-full">✓ Yanıtlandı</span>
                            : u.bildirimGonderildiMi
                              ? <span className="text-xs font-semibold bg-red-100 text-red-700 px-2.5 py-1 rounded-full">⚠ Bildirim Gönderildi</span>
                              : <span className="text-xs font-semibold bg-amber-100 text-amber-700 px-2.5 py-1 rounded-full">⏳ Bekliyor</span>}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            </>
          )}
        </div>
      )}

      {aktifSekme === 'sistem' && <>
      {/* Filtreler */}
      <div className="bg-white rounded-[2rem] border border-gray-100 shadow-xl p-6 md:p-8 z-20 relative">
        <h3 className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] mb-4">Log Filtreleme</h3>
        <div className="flex flex-wrap items-end gap-4">
          <div className="flex-1 min-w-[140px]">
             <label className="text-[10px] font-black text-gray-400 uppercase block mb-2.5 tracking-widest ml-1">Başlangıç</label>
             <div className="relative">
               <DatePicker value={baslar} onChange={function(v){
                 setBaslar(v);
                 var b=v.split('.').reverse().join('-');
                 var e=bitis.split('.').reverse().join('-');
                 if(new Date(b)>new Date(e)) setBitis(v);
               }} maxDate={bitis} />
             </div>
          </div>
          <div className="flex-1 min-w-[140px]">
             <label className="text-[10px] font-black text-gray-400 uppercase block mb-2.5 tracking-widest ml-1">Bitiş</label>
             <div className="relative">
               <DatePicker value={bitis} onChange={function(v){
                 var b=baslar.split('.').reverse().join('-');
                 var e=v.split('.').reverse().join('-');
                 if(new Date(e)<new Date(b)) setBitis(baslar);
                 else setBitis(v);
               }} minDate={baslar} />
             </div>
          </div>
          <div className="flex-[2] min-w-[200px]">
             <label className="text-[10px] font-black text-gray-400 uppercase block mb-2.5 tracking-widest ml-1">İşlem Ara</label>
             <input value={islem} onChange={e => setIslem(e.target.value)}
              placeholder="Anahtar kelime (örn. Misafir silindi)..."
              className="w-full bg-gray-50 border border-gray-200 rounded-2xl px-4 py-3 text-sm font-semibold text-gray-700 focus:outline-none focus:border-blue-400 transition-all placeholder-gray-300" />
          </div>
          <div className="flex flex-wrap gap-2 h-[46px]">
            <button onClick={filtrele} className="bg-slate-800 hover:bg-slate-900 text-white px-8 rounded-2xl font-black text-[10px] uppercase tracking-widest shadow-lg shadow-slate-200 transition-all h-full">FİLTRELE</button>
            <button onClick={temizle}  className="bg-gray-50 border-2 border-gray-100 text-gray-500 hover:bg-gray-100 px-6 rounded-2xl font-black text-[10px] uppercase tracking-widest transition-all h-full">SIFIRLA</button>
          </div>
        </div>
      </div>

      {/* Yükleniyor / Hata */}
      {yukleniyor && (
        <div className="flex items-center justify-center py-8 gap-3 text-gray-500">
          <div className="animate-spin w-5 h-5 border-2 border-blue-500 border-t-transparent rounded-full"/>
          <span className="text-sm">Yükleniyor...</span>
        </div>
      )}
      {hata && !yukleniyor && (
        <div className="bg-red-50 border border-red-200 rounded-xl p-4 text-red-700 text-sm font-medium">{hata}</div>
      )}

      {!yukleniyor && !hata && (
        <>
          {/* Özet istatistik kartları */}
          {liste.length > 0 && (
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-3">
              {[
                { tip:'giris',       label:'Giriş', bg:'bg-blue-50', text:'text-blue-600' },
                { tip:'rezervasyon', label:'Rezervasyon', bg:'bg-purple-50', text:'text-purple-600' },
                { tip:'checkin',     label:'Check-in', bg:'bg-indigo-50', text:'text-indigo-600' },
                { tip:'checkout',    label:'Check-out', bg:'bg-pink-50', text:'text-pink-600' },
                { tip:'gelir_ekle',  label:'Gelir', bg:'bg-emerald-50', text:'text-emerald-600' },
                { tip:'gider_ekle',  label:'Gider', bg:'bg-orange-50', text:'text-orange-600' },
                { tip:'odeme_ekle',  label:'Ödeme', bg:'bg-teal-50', text:'text-teal-600' },
                { tip:'misafir_ekle',label:'Misafir', bg:'bg-sky-50', text:'text-sky-600' },
              ].map(function(item) {
                var meta = TIP_META[item.tip] || {};
                var sayi = tipSayilari[item.tip] || 0;
                return (
                  <div key={item.tip} className={`relative overflow-hidden rounded-[1.5rem] p-4 group ${item.bg} border-2 border-white/50 shadow-md transition-all duration-300 hover:-translate-y-1 hover:shadow-xl`}>
                    <div className="flex items-center justify-between mb-2">
                       <span className={`text-[10px] font-black uppercase tracking-widest ${item.text}`}>{item.label}</span>
                       <span className="w-8 h-8 rounded-xl flex items-center justify-center text-sm bg-white shadow-sm font-emoji flex-shrink-0">{meta.ikon}</span>
                    </div>
                    <div className="text-xl font-black text-gray-900 tracking-tighter leading-none">{sayi}</div>
                  </div>
                );
              })}
            </div>
          )}

          {/* Kayıt sayısı */}
          <div className="flex items-center justify-between">
            <p className="text-sm font-semibold text-gray-700">
              Toplam <span className="text-blue-600 font-black">{liste.length}</span> kayıt listelenmiştir.
            </p>
          </div>

          {/* Tablo – Mobil Kartlar */}
          <div className="md:hidden space-y-2">
            {liste.length === 0 ? (
              <EmptyState icon="📋" text="Kayıt bulunamadı" />
            ) : listePage.map(function(log) {
              var meta = TIP_META[log.tip] || { label: log.tip, renk:'bg-gray-100 text-gray-600', ikon:'📝' };
              var acik = aciklar[log.id];
              return (
                <div key={log.id} className="bg-white border border-gray-200 rounded-xl p-3">
                  <div className="flex items-start justify-between mb-1.5">
                    <div>
                      <p className="text-xs font-bold text-gray-800">{log.tarih} <span className="text-gray-400 font-normal">{log.saat}</span></p>
                      <div className="flex items-center gap-2 mt-1 flex-wrap">
                        <span className={'text-xs font-semibold px-2 py-0.5 rounded-full ' + meta.renk}>{meta.ikon} {meta.label}</span>
                        {log.rol && <span className="text-xs bg-indigo-50 text-indigo-700 px-2 py-0.5 rounded-full font-semibold">{log.rol}</span>}
                      </div>
                    </div>
                    <span className="text-xs font-semibold text-gray-600 flex-shrink-0 ml-2">{log.kullanici || '—'}</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className="text-xs text-gray-700 flex-1 leading-relaxed">{log.mesaj}</span>
                    {log.detay && (
                      <button onClick={function() { toggleDetay(log.id); }}
                        className={'text-xs font-semibold px-2.5 py-1 rounded-lg border flex-shrink-0 transition-colors ' +
                          (acik ? 'bg-gray-200 text-gray-700 border-gray-300' : 'bg-blue-50 text-blue-600 border-blue-200')}>
                        {acik ? '▲ Gizle' : '▼ Detay'}
                      </button>
                    )}
                  </div>
                  {acik && log.detay && <div className="mt-2"><DetayTablo detay={log.detay} /></div>}
                </div>
              );
            })}
          </div>

          {/* Tablo – Masaüstü */}
          <div className="hidden md:block bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full text-sm border-collapse">
                <thead>
                  <tr className="bg-gray-50 border-b-2 border-gray-200">
                    <th onClick={function(){ handleSort('tarih'); }}
                      className="py-3 px-4 text-xs font-semibold text-gray-700 text-left cursor-pointer hover:bg-gray-100 select-none whitespace-nowrap w-44">
                      Tarih/Saat <SortIcon field="tarih" sortKey={sortKey} sortDir={sortDir}/>
                    </th>
                    <th onClick={function(){ handleSort('kullanici'); }}
                      className="py-3 px-4 text-xs font-semibold text-gray-700 text-left cursor-pointer hover:bg-gray-100 select-none whitespace-nowrap w-36">
                      Personel <SortIcon field="kullanici" sortKey={sortKey} sortDir={sortDir}/>
                    </th>
                    <th className="py-3 px-4 text-xs font-semibold text-gray-700 text-left whitespace-nowrap w-28">
                      Rol
                    </th>
                    <th className="py-3 px-4 text-xs font-semibold text-gray-700 text-left">
                      İşlem Detayı
                    </th>
                  </tr>
                  <tr className="bg-white border-b border-gray-100">
                    <td className="px-3 py-1.5 w-44">
                      <input value={colTarih} onChange={function(e){setColTarih(e.target.value);}} placeholder="Tarih/Saat" className={INP_COL}/>
                    </td>
                    <td className="px-3 py-1.5 w-36">
                      <input value={colPersonel||''} onChange={function(e){setColPersonel(e.target.value);}} placeholder="Personel" className={INP_COL}/>
                    </td>
                    <td className="px-3 py-1.5 w-28"></td>
                    <td className="px-3 py-1.5">
                      <input value={colIslem} onChange={function(e){setColIslem(e.target.value);}} placeholder="İşlem" className={INP_COL}/>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {liste.length === 0 ? (
                    <EmptyState as="td" colSpan={4} icon="📋" text="Kayıt bulunamadı" />
                  ) : listePage.map(function(log, idx) {
                    var meta = TIP_META[log.tip] || { label: log.tip, renk:'bg-gray-100 text-gray-600', ikon:'📝' };
                    var acik = aciklar[log.id];
                    return (
                      <tr key={log.id}
                        className={'border-b border-gray-100 align-top ' + (idx%2===0 ? 'bg-white' : 'bg-gray-50/50')}>
                        <td className="py-3 px-4 whitespace-nowrap align-top">
                          <div className="text-xs font-bold text-gray-800">{log.tarih}</div>
                          <div className="text-xs text-gray-400">{log.saat}</div>
                          <div className="mt-1">
                            <span className={'text-xs font-semibold px-2 py-0.5 rounded-full ' + meta.renk}>
                              {meta.ikon} {meta.label}
                            </span>
                          </div>
                        </td>
                        <td className="py-3 px-4 whitespace-nowrap align-top">
                          <span className="text-xs font-semibold text-gray-700">{log.kullanici || '—'}</span>
                        </td>
                        <td className="py-3 px-4 whitespace-nowrap align-top">
                          {log.rol
                            ? <span className="text-xs bg-indigo-50 text-indigo-700 px-2 py-0.5 rounded-full font-semibold">{log.rol}</span>
                            : <span className="text-xs text-gray-300">—</span>}
                        </td>
                        <td className="py-3 px-4">
                          <div className="flex items-start gap-2">
                            <span className="text-xs text-gray-700 flex-1 leading-relaxed pt-0.5">{log.mesaj}</span>
                            {log.detay && (
                              <button
                                onClick={function(){ toggleDetay(log.id); }}
                                className={'text-xs font-semibold px-2.5 py-1 rounded-lg border transition-colors flex-shrink-0 ' +
                                  (acik
                                    ? 'bg-gray-200 text-gray-700 border-gray-300 hover:bg-gray-300'
                                    : 'bg-blue-50 text-blue-600 border-blue-200 hover:bg-blue-100')}>
                                {acik ? '▲ Gizle' : '▼ Detay'}
                              </button>
                            )}
                          </div>
                          {acik && log.detay && (
                            <DetayTablo detay={log.detay}/>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          <Pagination toplam={toplamKayit} sayfaBasi={sayfaBasi} sayfaBasiDegistir={(v) => { setSayfaBasi(v); setAktifSayfa(1); }} aktifSayfa={aktifSayfa} sayfaDegistir={setAktifSayfa} />
        </>
      )}
      </>}

      <UsageInfo
        color="slate"
        description="Log Kayıtları modülü, işletmedeki veriler üzerinde kimin ne zaman hangi işlemi yaptığını izleyen şeffaf bir 'Kara Kutu' işlevi görür. Otelde bir bilgi silindiğinde veya eklendiğinde sorumlusunu bulmak için burayı kullanın."
        scenarios={[
          { title: "Personel Güvenliği", content: "Bir personelin veya menajerin hangi rezervasyonlarda ne zaman check-in/check-out işlemi yaptığını hızlıca listeleyebilir, filtrelerden ismine göre aratabilirsiniz." },
          { title: "Uyarı / Görev Logları", content: "Uyarı Logları sekmesi size, hangi personelinize gönderilen otomatik kat veya hatırlatıcı bildirimlerinin ne kadar sürede yanıtlandığını listeler. Yöneticiler verimlilik ölçümü için kullanır." },
          { title: "Detay İzleme", content: "Bazı işlemlerin (Özellikle rezervasyon/finans girişlerinin) sağında yer alan '▼ Detay' butonu tıklandığında yapılan değişikliğin öncesi/sonrası gibi derin veri yapıları görüntülenebilir." }
        ]}
      />
    </div>
  );
}
